import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ProfileMain from './components/ProfileMain';
// import ProfileCalendar from './components/ProfileCalendar';
// import ProfileTasks from './components/ProfileTasks';
import ProfileTabs from './components/ProfileTabs';

const Profile = () => (
  <Container>
    <div className="profile">
      <Row>
        <Col md={12} lg={12} xl={12}>
          <Row>
            <ProfileMain />
          </Row>
        </Col>
      </Row>
      <Row>
        <ProfileTabs />
      </Row>
    </div>
  </Container>
);

export default Profile;
